import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { forwardRef } from 'react';
import { element, string, oneOfType, arrayOf, node, bool } from 'prop-types';
import propTypes from '@styled-system/prop-types';
import { Link as LinkElement } from './link.styles';
const Link = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  const type = props != null && props.href ? 'a' : 'button';
  return /*#__PURE__*/React.createElement(LinkElement, _extends({
    ref: ref,
    "data-testid": "link",
    as: type
  }, props), children);
});
process.env.NODE_ENV !== "production" ? Link.propTypes = Object.assign({
  children: oneOfType([element, string, arrayOf(element), node]),
  href: string,
  colorOnHover: string,
  hover: bool,
  underline: bool,
  underlineOnHover: bool
}, propTypes.background, propTypes.border, propTypes.flexbox, propTypes.layout, propTypes.space, propTypes.typography, propTypes.textAlign, propTypes.color) : void 0;
Link.defaultProps = {
  hover: true,
  underline: false,
  underlineOnHover: true,
  bg: 'transparent'
};
Link.displayName = 'Link';
export default Link;